import React from 'react';

export const FormFieldContext = React.createContext({
  disabled: false,
  formElementType: null,
  hasContent: false,
  hasPlaceholder: false,
  id: '',
  invalid: false,
  isFocused: false,
  isActive: false,
  required: false,
  value: '',
  setDisabled: () => null,
  setFormElementType: () => null,
  setHasPlaceholder: () => null,
  setHasContent: () => null,
  setId: () => null,
  setInvalid: () => null,
  setRequired: () => null,
  setValue: () => null,
  toggleFocus: () => null,
  setActive: () => null
});

export const FormFieldProvider = FormFieldContext.Provider;
export const FormFieldConsumer = FormFieldContext.Consumer;
export default FormFieldContext;
